<div class="upload-container" [ngClass]="{'files-exit': uploadedFiles && uploadedFiles.length > 0}">
  <p-fileUpload #fubauto name="demo[]" [ngClass]="{'d-none': uploadedFiles && uploadedFiles.length > 0}"
    (onSelect)="onSelect($event)" accept=".pdf">
  </p-fileUpload>
  <ng-template [ngIf]="!uploadedFiles || (uploadedFiles && uploadedFiles.length === 0)" *ngIf="isEditVisa">
    <img class="upload-pdf-img" src="assets/images/PDF_file_icon.svg" alt="PDF">
    <span class="upload-bold-txt">Convert your PDF to online form</span>
    <span class="upload-normal-txt">Drag and Drop a PDF from here</span>
    <span class="upload-normal-txt">OR</span>
    <div class="upload-choose-btn">UPLOAD PDF FORM</div>
  </ng-template>
  <ng-template [ngIf]="uploadedSuccessfully">
    <div class="upload-success">
      <i class="pi pi-check"></i>
      <span>PDF uploaded successfully.</span>
      <a href="javascript:void" (click)="nextStep()">NEXT</a>
    </div>
  </ng-template>
  <ng-template [ngIf]="uploadedFiles && uploadedFiles.length > 0" *ngIf="isEditVisa">
    <div class="selected-file-holder container-fluid">
      <div class="row">
        <div class="col-6">
          <input type="text" class="uploaded-file-txt" [(ngModel)]="uploadedFileName">
        </div>
        <div class="col-6">
          <div class="float-right">
            <p-button icon="pi pi-trash" class="selected-file-delete" (click)="deleteSelected(fubauto)"  *ngIf="isEditVisa"></p-button>
            <p-button label="UPLOAD" class="selected-file-upload" (click)="onUpload(fubauto)"  *ngIf="isEditVisa"></p-button>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  <div class="uploaded-file-list" *ngIf="fileList && fileList.length > 0">
    <p-table [value]="fileList" [reorderableColumns]="true" responsiveLayout="scroll">
      <ng-template pTemplate="header" let-columns>
        <tr>
          <th scope="col">
          </th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-file let-index="rowIndex">
        <tr [pReorderableRow]="index">
          <td>
            <p-accordion>
              <p-accordionTab [header]="file.displayName">
                <iframe [src]="file.pdfURL" noborder="0" width="100%" height="800" scrolling="yes" seamless></iframe>
              </p-accordionTab>
            </p-accordion>
            <p-button icon="pi pi-trash" class="uploaded-file-delete" (click)="deleteUploaded(file)" *ngIf="isEditVisa"></p-button>
            <span class="pi pi-bars" pReorderableRowHandle></span>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
<p-divider type="dashed"></p-divider>
<div class="row">
  <div class="col-6 offset-6">
    <div class="float-right">
      <button type="button" class="btn vdCancelBtn mr-3" (click)="back()">BACK</button>
      <button type="button" class="btn vdCreateBtn mr-3" (click)="nextStep()">NEXT</button>
    </div>
  </div>
</div>
